import * as tslib_1 from "tslib";
import { Store, select } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';
import { getMenuRoute } from '@awp/core/ngrx';
import { MenuService } from '@awp/app-common';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../../../app-common/src/lib/menu.service";
var CurrentMenuQuery = /** @class */ (function () {
    function CurrentMenuQuery(store, menuService) {
        this.store = store;
        this.menuService = menuService;
    }
    Object.defineProperty(CurrentMenuQuery.prototype, "values", {
        get: function () {
            return this.store
                .pipe(select(getMenuRoute), withLatestFrom(this.menuService.values), map(function (_a) {
                var _b = tslib_1.__read(_a, 2), menuId = _b[0], menuItems = _b[1];
                return menuItems.find(function (p) { return p.url === menuId; });
            }));
        },
        enumerable: true,
        configurable: true
    });
    CurrentMenuQuery.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CurrentMenuQuery_Factory() { return new CurrentMenuQuery(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.MENU_TOKEN)); }, token: CurrentMenuQuery, providedIn: "root" });
    return CurrentMenuQuery;
}());
export { CurrentMenuQuery };
